var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 306,
    viewBox: "0 0 287 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.7 152.9V76.5L181.4 0H28.5V152.9H0V248.4H28.5V305.7H257.7L258 248.4H286.5V152.9H257.7Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.1 85.9V9.60001H38.1V152.9H248.3V85.9H172.1ZM181.4 12.9V76.5H245L181.4 12.9ZM38.1 296.1H248.3V248.3H38.1V296.1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.876 222.5V202.556H111.132V193.556H87.876V183.476H111.636V174.476H77.652V222.5H87.876Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.009 222.5V174.476H118.785V222.5H129.009Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.711 222.5V213.5H148.407V174.476H138.111V222.5H168.711Z",
    fill: "#F9F9F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.581 222.5V213.5H185.821V202.556H209.077V193.556H185.821V183.476H209.581V174.476H175.597V222.5H209.581Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8af84dd0fb7d0f5795d4e50e855cf1a5.svg";
export { ForwardRef as ReactComponent };